import { render, staticRenderFns } from "./CategoryLevel2Bar.vue?vue&type=template&id=0bbb34de&scoped=true&"
import script from "./CategoryLevel2Bar.vue?vue&type=script&lang=js&"
export * from "./CategoryLevel2Bar.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLevel2Bar.vue?vue&type=style&index=0&id=0bbb34de&prod&lang=scss&scoped=true&"
import style1 from "./CategoryLevel2Bar.vue?vue&type=style&index=1&id=0bbb34de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbb34de",
  null
  
)

export default component.exports
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QScrollArea,QTabs,QTab});
